import { message } from 'components';
import { useTransferChatSessionMutation } from 'services';

export const useTransferChatSession = () => {
  const [handleTransfer, { isLoading }] = useTransferChatSessionMutation();

  const onTransferChatSession = (chatSessionAssign: number) => {
    return handleTransfer({
      chatSessionId: chatSessionAssign
    })
      .unwrap()
      .then((rs) => message.systemSuccess(rs.message));
  };

  return {
    onTransferChatSession,
    isLoading
  };
};
